import * as React from 'react';
import { Modal, Empty } from 'antd';
import { ApnExportManufacturer } from './ApnExportManufacturer';
import { ApnFields } from '../ApnFilter';
import { LoaderBox } from '../LoaderBox';
import { ApnExportStore } from './ApnExportStore';
import { observer } from 'mobx-react';

interface PropsApnExport {
  visible: boolean;
  onClose(): void;
  filter: ApnFields;
}

const ApnExportInner: React.FC<{ filter: ApnFields }> = observer(({ filter }) => {
  const [store] = React.useState(new ApnExportStore(filter));
  const onClose = () => {};
  React.useEffect(() => store.init(), [store]);
  const isEmpty = store.manufList.length === 0;
  return (
    <LoaderBox store={store}>
      {isEmpty ? (
        <Empty />
      ) : (
        store.manufList.map(info => (
          <ApnExportManufacturer key={info.manufacturerId} info={info} onClose={onClose} />
        ))
      )}
    </LoaderBox>
  );
});

export const ApnExport: React.FC<PropsApnExport> = ({ visible, onClose, filter }) => {
  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      title='RFQ file export'
      maskClosable={false}
      destroyOnClose
      footer={null}
    >
      <ApnExportInner filter={filter} />
    </Modal>
  );
};
